import { Injectable } from '@angular/core';
import { AppSettings } from 'app/app.settings';
import { CommonRequestService } from './common-request.service';
import * as jstsGeom from 'jsts/org/locationtech/jts/geom';
import * as jstsPrecision from 'jsts/org/locationtech/jts/precision';
import { v1 as uuid } from 'uuid';
import * as topojson from 'topojson-server';

import GeoJSON from 'ol/format/GeoJSON';
import TopoJSON from 'ol/format/TopoJSON';
import { UserService } from './user.service';
import { JstsService } from './jsts.service';
import { MainDataMapLayersService } from './main-data-map-layers.service';

export interface TopoCheckArea {
	geom: {
		type: string; // like 'Polygon'
		coordinates: any[];
	};
	gid;
	source: string;
}
export interface TopoCheckAreaIndex {
	// gids: string[];
	ori_gids: string[];
	topo_gid;
	// size: number;
}
export interface TopoCheckCrevice {
	geomJson: {
		type: string;
		coordinates: any[];
	},
	creviceId: string;
}
export interface TopoCheckOutput {
	// creviced_areas?: TopoCheckArea[];
	//
	gap: TopoCheckAreaIndex[];
	overlap: TopoCheckAreaIndex[];
	topologized_areas: TopoCheckArea[];
	resolve: {
		ori_gid: string;
		topo_gids: string[];
	}[];
	crevice: TopoCheckCrevice[];
	//
	resolved_areas?: TopoCheckArea[];
}

export interface TopoCheckOutputExt extends TopoCheckOutput {
	geojsonOrigin?; // origin geojson
	geojson?; // geojson that corresponds to the current topo check result

	changedFeatureIds?: any[]; // features that change during fixin/resolvinggtopo errors;
}
export interface TopoCheckInterLayerOutput {
	foList: TopoCheckInterLayerError[];
	soList: TopoCheckInterLayerError[];
	topologized_areas: TopoCheckArea[];
	resolve: {
		ori_gid: string;
		topo_gids: string[];
	}[];
}
export interface TopoCheckInterLayerOutputExt extends TopoCheckInterLayerOutput {
	geojsonOrigin?: any; // origin geojson
	geojson?: any; // geojson that corresponds to the current topo check result

	changedFeatureIds?: any[]; // features that change during fixin/resolvinggtopo errors;
}
export type TopoErrorType_InterLayer = 'fo' | 'so';
export interface TopoCheckInterLayerError {
	topo_gid: string;
	ori_gid: string;
	reso_gids: string[];
	topo_err: TopoErrorType_InterLayer;
}
@Injectable({
	providedIn: 'root'
})
export class TopoService {

	precision = 0.001;
	turnOffPrecision = false;

	constructor(
		private requestService: CommonRequestService,
		private jstsService: JstsService,
		private mapLayerService: MainDataMapLayersService,
		private userService: UserService
	) { }

	getTopologizedzedAreas(areaGeojson, topoError?: boolean) {
		return new Promise<TopoCheckOutput>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'azgiv/topologizedAreas';
			const body = {
				areaGeojson: JSON.stringify(areaGeojson),
				topoError: topoError
			};
			this.requestService.requestPost(url, body, (rsp) => {
				const result: TopoCheckOutput = {
					gap: [],
					overlap: [],
					topologized_areas: [],
					resolve: [],
					crevice: []
				};
				const data = rsp.data;
				if (data) {
					if (data.topologized_areas && data.topologized_areas.length) {
						result.topologized_areas = data.topologized_areas;
					}
					if (data.err) {
						(<any[]>data.err).forEach(i => {
							if (i.topo_err === 'o') {
								result.overlap.push({
									ori_gids: i.ori_gid.split(','),
									topo_gid: i.topo_gid
								});
							} else if (i.topo_err === 'g') {
								result.gap.push({
									ori_gids: i.ori_gid.split(','),
									topo_gid: i.topo_gid
								});
							} else if (i.topo_err === 'c') {
								result.crevice.push({
									geomJson: i.geom,
									creviceId: uuid()
								});
							}
						});
					}
					if (data.reso) {
						(<any[]>data.reso).forEach(i => {
							let resolveItem = result.resolve.find(r => r.ori_gid === i.ori_gid);
							if (!resolveItem) {
								resolveItem = {
									ori_gid: i.ori_gid,
									topo_gids: i.topo_gid.split(',')
								};
								result.resolve.push(resolveItem);
							} else {
								resolveItem.topo_gids = resolveItem.topo_gids.concat(i.topo_gid.split(','));
							}
						});
					}
				}
				resolve(result);
					// const result: TopoCheckOutput = {};
					// const data = rsp.data;
					// if (data) {
					// 	if (data.crevice && data.crevice.length) {
					// 		result.crevice = (<any[]>data.crevice).map(d => {
					// 			return {
					// 				topo_gid: d.gid,
					// 				gids: d.gids.split(','),
					// 				size: d.siz
					// 			}
					// 		});
					// 	}
					// 	if (data.creviced_areas && data.creviced_areas.length) {
					// 		result.creviced_areas = data.creviced_areas;
					// 	}
					// 	if (data.gap && data.gap.length) {
					// 		result.gap = (<any[]>data.gap).map(d => {
					// 			return {
					// 				gids: d.gids.split(','), // d.gids is a string of ids separated by ',' e.g. 'abcd,aser,buo'
					// 				topo_gid: d.topo_gid,
					// 				size: d.siz
					// 			}
					// 		});
					// 	}
					// 	if (data.overlap && data.overlap.length) {
					// 		result.overlap = (<any[]>data.overlap).map(d => {
					// 			return {
					// 				gids: d.gids.split(','),
					// 				topo_gid: d.topo_gid,
					// 				size: d.siz
					// 			}
					// 		});
					// 	}
					// 	if (data.topologized_areas && data.topologized_areas.length) {
					// 		result.topologized_areas = data.topologized_areas;
					// 	}
					// }
					// resolve(result);
			}, err => reject(err));
		})
	}
	getTopologizedzedAreasByLayer(layerId) {
		return new Promise<TopoCheckOutput>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'azgiv/topologizedAreas';
			const body = {
				layerId: layerId
			};
			this.requestService.requestPost(url, body, (rsp) => {
				const result: TopoCheckOutput = {
					gap: [],
					overlap: [],
					topologized_areas: [],
					resolve: [],
					crevice: [],
					resolved_areas: []
				};
				const data = rsp.data;
				if (data) {
					if (data.topologized_areas && data.topologized_areas.length) {
						result.topologized_areas = data.topologized_areas;
					}
					if (data.resolved_areas && data.resolved_areas.length) {
						result.resolved_areas = data.resolved_areas;
					}
					if (data.err) {
						(<any[]>data.err).forEach(i => {
							if (i.topo_err === 'o') {
								result.overlap.push({
									ori_gids: i.ori_gid.split(','),
									topo_gid: i.topo_gid
								});
							} else if (i.topo_err === 'g') {
								result.gap.push({
									ori_gids: i.ori_gid.split(','),
									topo_gid: i.topo_gid
								});
							} else if (i.topo_err === 'c') {
								result.crevice.push({
									geomJson: i.geom,
									creviceId: uuid()
								});
							}
						});
					}
					if (data.reso) {
						(<any[]>data.reso).forEach(i => {
							let resolveItem = result.resolve.find(r => r.ori_gid === i.ori_gid);
							if (!resolveItem) {
								resolveItem = {
									ori_gid: i.ori_gid,
									topo_gids: i.topo_gid.split(',')
								};
								result.resolve.push(resolveItem);
							} else {
								resolveItem.topo_gids = resolveItem.topo_gids.concat(i.topo_gid.split(','));
							}
						});
					}
				}
				resolve(result);
			}, err => reject(err));
		})
	}
	getTopologizedAreasInter(subGeojson: any, refGeojson: any, topoError?: boolean, gridSize?: number) {
		return new Promise<TopoCheckInterLayerOutput>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'azgiv/topologizedAreasInter';
			const body: any = {
				areaSubjectGeojson: JSON.stringify(subGeojson),
				areaReferenceGeojson: JSON.stringify(refGeojson),
				topoError: topoError
			};
			if (gridSize || gridSize === 0) {
				body.gridSize = gridSize;
			}
			this.requestService.requestPost(url, body, (rsp: any) => {
				const result: TopoCheckInterLayerOutput = {
					foList: [],
					soList: [],
					topologized_areas: [],
					resolve: []
				};
				const data = rsp.data;
				if (data) {
					if (data.err) {
						(<any[]>data.err).forEach(i => {
							const err: TopoCheckInterLayerError = {
								topo_gid: i.topo_gid,
								ori_gid: this.extractId(i.ori_gid),
								reso_gids: (<string>i.reso_gid).split(',').map(id => this.extractId(id)),
								topo_err: i.topo_err
							}
							if (err.topo_err === 'fo') {
								result.foList.push(err);
							} else if (err.topo_err === 'so') {
								result.soList.push(err);
							} else {
								console.log('error type not handled')
							}
						});
					}
					if (data.topologized_areas) {
						result.topologized_areas = data.topologized_areas;
					}
					if (data.topologized_subs) {
						(<any[]>data.topologized_subs).forEach(i => {
							const oriGid = this.extractId(i.ori_gid);
							let resolveItem = result.resolve.find(r => r.ori_gid === oriGid);
							if (!resolveItem) {
								resolveItem = {
									ori_gid: oriGid,
									topo_gids: i.topo_gid.split(',')
								};
								result.resolve.push(resolveItem);
							} else {
								resolveItem.topo_gids = resolveItem.topo_gids.concat(i.topo_gid.split(','));
							}
						});
					}

					// Add ref errors to resolve
					if (result.foList.length) {
						result.foList.forEach(i => {
							const resolveItem = result.resolve.find(r => r.ori_gid === i.reso_gids[0]);
							if (resolveItem) {
								resolveItem.topo_gids.push(i.topo_gid);
							}
						});
					}
				}
				resolve(result);
			}, err => {
				reject(err);
			});
		})
	}
	resolveTopo(layerId) {
		return new Promise<any>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'azgiv/resolveTopo';
			const body: any = {
				layerId: layerId,
				userSubscriptionId: this.userService.getUserInfo().userSubId
			};
			return this.requestService.requestPost(url, body, rsp => resolve(rsp), err => reject(err));
		});
	}
	qcLayerAreaTopo(layerId) {
		return new Promise<any>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'azgiv/qcLayerAreaTopo';
			const params: any = {
				layerId: layerId,
				userSubscriptionId: this.userService.getUserInfo().userSubId
			};
			this.requestService.requestGet(url, {
				params: params
			}, (rsp) => {
				console.log(rsp)
				debugger
				resolve(rsp);
			}, err => reject(err));
		})
	}
	private extractId(rawId: string) {
		return rawId.split(': ')[1];
	}

	resolveOverlapsAndGaps(topoCheck: TopoCheckOutputExt) {
		if (!topoCheck) {
			return;
		}
		topoCheck = JSON.parse(JSON.stringify(topoCheck));

		const parser = this.jstsService.getJstsParser();
		const geojsonFormat = new GeoJSON();

		let geometryPrecisionReducer;
		if (!this.turnOffPrecision) {
			const precisionModel = new jstsGeom.PrecisionModel(1 / this.precision);
			geometryPrecisionReducer = new jstsPrecision.GeometryPrecisionReducer(precisionModel);	
		}

		const topoAreas = topoCheck.topologized_areas;
		const newGeojson = { // For TOPOLOGY state layer fix use
			type: 'FeatureCollection',
			features: []
		}
		topoCheck.resolve.forEach(i => {
			const dataGid = i.ori_gid;
			let dataJsts: any;
			i.topo_gids.forEach(topoGid => {
				const topo = topoAreas.find(t => t.gid === topoGid);
				const topoGeom = geojsonFormat.readGeometry(topo.geom);
				const topoJsts = parser.read(topoGeom);
				if (!dataJsts) {
					dataJsts = topoJsts;
				} else {
					dataJsts = dataJsts.union(topoJsts);
				}
			});

			if (geometryPrecisionReducer) {
				dataJsts = geometryPrecisionReducer.reduce(dataJsts);
			}
			const updatedGeom = parser.write(dataJsts);
			const updatedGeojson = JSON.parse(geojsonFormat.writeGeometry(updatedGeom));
			if (topoCheck.geojson) {
				const dataGeojson = topoCheck.geojson.features.find((f: any) => f.id === dataGid);
				dataGeojson.geometry.type = updatedGeojson.type;
				dataGeojson.geometry.coordinates = updatedGeojson.coordinates;
			} else {
				newGeojson.features.push({
					type: 'Feature',
					geometry: updatedGeojson
				});
			}
		});

		if (!topoCheck.geojson) {
			topoCheck.geojson = newGeojson;
		}

		// Get changed features
		if (!topoCheck.changedFeatureIds) {
			topoCheck.changedFeatureIds = [];
		}
		const originIds = topoCheck.changedFeatureIds;
		topoCheck.gap.forEach(g => {
			const changedId = g.ori_gids[0]; // assume the gap is merged to first id in ori_gids
			if (originIds.indexOf(changedId) === -1) {
				originIds.push(changedId);
			}
		});
		topoCheck.overlap.forEach(o => {
			o.ori_gids.forEach(changedId => {
				if (originIds.indexOf(changedId) === -1) {
					originIds.push(changedId);
				}
			});
		});
		
		return topoCheck;
	}

	checkShowCreviceOnly(topoCheck: TopoCheckOutput) {
		return !topoCheck.overlap.length && !topoCheck.gap.length && !!topoCheck.crevice.length;
	}

	convertGeojsonToTopoFeatures(geojson) {

		// const geoj = this.editService.getTestGeojson();
		// const geojFormat = new GeoJSON();
		// const geojFeats = geojFormat.readFeatures(geoj);
		// this.mapService.map.addedLayers[this.topologyErrorLayerName].getSource().addFeatures(geojFeats);
		// setTimeout(() => this.mapService.map.zoomToLayer(this.mapService.map.addedLayers[this.topologyErrorLayerName]))
		// //

		// const geojsonFormat = new GeoJSON();
		// const geojFeatures = geojsonFormat.readFeatures(geojson);
		// const wktFormat = new WKT();
		// const polygonWKT = wktFormat.writeFeatures(geojFeatures);
		// const polygonizer = new jsts.operation.polygonize.Polygonizer();
		// const reader = new jsts.io.WKTReader();
		// reader.read(polygonWKT);
		// //
		// const geojReader = new jsts.io.GeoJSONReader();
		// const geojWriter = new jsts.io.GeoJSONWriter();
		// let union;
		// geojson.features.forEach((f, idx) => {
		// 	const geom = geojReader.read(f.geometry);
		// 	if (idx === 0) {
		// 		union = geom;
		// 	} else {
		// 		union = union.union(geom);
		// 	}
		// });
		// if (union) {
		// 	polygonizer.add(union);
		// 	const output = {type: "FeatureCollection", features: []};
		// 	polygonizer.getPolygons().array.forEach(p => {
		// 		const f = {type: "Feature", properties: {}, geometry: geojWriter.write(p)};
		// 		output.features.push(f);
		// 	});

		// 	const final = geojsonFormat.readFeatures(output);
		// 	// this.mapService.map.addedLayers[this.topologyErrorLayerName].getSource().addFeatures(final);
		// 	// setTimeout(() => this.mapService.map.zoomToLayer(this.mapService.map.addedLayers[this.topologyErrorLayerName]))
		// 	// geojson = output;
		// 	return []
		// }



		const config = {};
		config[this.mapLayerService.topojsonFormatLayer] = geojson;
		// const quant = 1e6;
		const topology = topojson.topology(config);
		const topojsonFormat = new TopoJSON({
			layers: [this.mapLayerService.topojsonFormatLayer]
		});
		const features = topojsonFormat.readFeatures(topology);

		// const testFeature = topojsonClient.feature(topology, this.topojsonFormatLayer);

		return features;
	}
}
